import { useEngineStore } from "../store/engineStore";

export function Telemetry() {
  const count = useEngineStore((s) => s.nodes.length);
  const generating = useEngineStore((s) => s.isGenerating);
  if (!count) {
    return (
      <div className="status">
        <span className="live-dot" />
        <strong>VOID IDLE</strong>
      </div>
    );
  }
  return (
    <>
      <div className="status">
        <span className="live-dot" />
        <strong>{generating ? "MAPPING" : "FIELD ACTIVE"}</strong>
        <span>{count} WORLDS</span>
      </div>
      <footer>
        <span>AUDIO FUTURE VOID ENGINE</span>
        <span>Drag to look 360 · click a world to expand</span>
        <span>INFINITE GRAPH</span>
      </footer>
    </>
  );
}
